import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { defaultContainerSize, mq } from 'styles/mixins';

export const Section = styled.section`
  background-color: ${({ theme }) => theme.colors.light_grey};
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  ${defaultContainerSize};
  padding-top: 6.5rem;
  padding-bottom: 6.5rem;
`;

export const Title = styled.h3`
  font-weight: 400;
  font-family: ${({ theme }) => theme.font.questrial};
  font-size: 2rem;
  line-height: 2.5rem;
  color: ${({ theme }) => theme.colors.core_black};
  margin: 0 0 1.5rem 0;

  ${mq.medium(css`
    font-size: 3rem;
    line-height: 3.5rem;
    letter-spacing: -0.0125rem;
    margin-bottom: 2.375rem;
  `)};
`;

export const Text = styled.p`
  font-size: 1rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.core_black};
  font-family: ${({ theme }) => theme.font.nunito};
  letter-spacing: 0.0125rem;
  font-weight: 300;
  margin: 0 0 2.125rem 0;
  max-width: 41.875rem;
`;

export const Bold = styled.strong`
  font-weight: 700;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto;
  gap: 1.5rem;

  ${mq.xLarge(css`
    grid-template-rows: 1fr;
    grid-template-columns: auto auto;
  `)};
`;

export const ImagesContainer = styled.div`
  position: relative;
  display: flex;
  gap: 0.5rem;
  overflow-x: scroll;
  max-height: 13.9375rem;
  padding-bottom: 1rem;

  ${mq.xLarge(css`
    max-height: 27.75rem;
    display: grid;
    grid-template-rows: auto auto;
    grid-auto-flow: column;
  `)};

  ::-webkit-scrollbar {
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  min-width: 17.90625rem;
  min-height: 12.9375rem;
  max-width: 17.90625rem;
  max-height: 12.9375rem;

  ${mq.xLarge(css`
    max-height: 13.25rem;
  `)};

  img {
    max-width: 17.90625rem;
    max-height: 12.9375rem;

    ${mq.xLarge(css`
      max-height: 13.25rem;
    `)};
  }
`;

export const VideoImageContainer = styled.div`
  position: relative;
  width: 100%;
  min-width: 100%;
  max-width: 21.4375rem;
  min-height: 25rem;
  max-height: 26.6875rem;
  border-radius: 0.5rem;

  ${mq.xLarge(css`
    max-width: 23.125rem;
  `)};

  img {
    border-radius: 0.5rem;
    min-width: 100%;
    max-width: 21.4375rem;
    min-height: 25rem;
    max-height: 26.6875rem;
    object-fit: cover;

    ${mq.xLarge(css`
      max-width: 23.125rem;
    `)};
  }
`;

export const PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 2rem;
  max-width: 5.5rem;
  max-height: 5.5rem;
  border: none;
  box-shadow: none;
  background-image: linear-gradient(
    100.54deg,
    #0e4ed7 0%,
    #7b4b93 48.44%,
    #f94743 100%
  );
  border-radius: 100%;
`;
